import { useEffect } from "react";
import { GoabFormItem, GoabInput } from "@abgov/react-components";
import { onlyNumberKey } from "../../utils/globalUtility"; 

const FNIHBNumber = ({ form, getResourceValue, setFormData }) => {
  useEffect(() => {
    onlyNumberKey("FNIHB");
  }, []);

  const handleBlur = (name) => {
    form.setFieldTouched(name, true);
  }

  const handleChange = (name, value, titleCase = false) => {
    delete form.errors[name];
    form.setFieldValue(name, value);
    if (setFormData) {
      const formValue = {...form.values, [name]: value};
      setFormData(formValue);
    }

  };

  return (
    <GoabFormItem
      label={getResourceValue({ key: "RESOURCES@form.FNIHB.label" })}
      error={
        form.errors.FNIHB &&
        form.touched.FNIHB &&
        getResourceValue({ key: form.errors.FNIHB })
      }
      requirement="optional"
      id="FNIHB"
      helpText={getResourceValue({ key: "RESOURCES@form.FNIHB.help_text" })}
    >
      <GoabInput
        name="FNIHB"
        id="FNIHB"
        maxLength="8"
        leadingContent="B"
        required="false"
        value={form.values.FNIHB}
        onBlur={({name}) => handleBlur(name)}
        onChange={({name, value, titleCase}) => handleChange(name, value, titleCase)}
        error={
          form.errors.FNIHB &&
          form.touched.FNIHB &&
          getResourceValue({ key: form.errors.FNIHB })
        }
      />
    </GoabFormItem>
  );
};

export default FNIHBNumber;
